import controller from './custom-permission-modal-controller';
import template from './custom-permission-modal.html';

const customPermissionComponent = {
    bindings: {
        modalInstance: '<',
        resolve: '<'
    },
    controller,
    template
};

export default customPermissionComponent;



// WEBPACK FOOTER //
// ./app/components/user-admin/custom-permission-modal/custom-permission-modal-component.js